export const DASHBOARD_METRICS_URL = "/link/getmet";
export const ALL_LINKS_URL = "/link/all";
export const LOGIN_URL = "/auth";
